import { UserRoles } from '@dynamika-shared/types/auth';
import { projectManagerModules } from './projectManager';
import { sponsorModules } from './sponsor';
import { siteModules } from './site';
import { imagingSpecialistModules } from './imagingSpecialist';
import { readerModules } from './reader';
import { userModules } from './user';
import { dataManagerModules } from './dataManager';
import { adminModules } from './admin';
import { supportModules } from '@restore/roleModules/support';
import { externalUserModules } from './externalUser';
import { validationSpecialistModules } from './validationSpecialist';

export const roleModules = {
  [UserRoles.ADMIN]: adminModules,
  [UserRoles.PROJECT_MANAGER]: projectManagerModules,
  [UserRoles.SPONSOR]: sponsorModules,
  [UserRoles.SITE]: siteModules,
  [UserRoles.IMAGING_SPECIALIST]: imagingSpecialistModules,
  [UserRoles.READER]: readerModules,
  [UserRoles.USER]: userModules,
  [UserRoles.DATA_MANAGER]: dataManagerModules,
  [UserRoles.SUPPORT]: supportModules,
  [UserRoles.EXTERNAL_USER]: externalUserModules,
  [UserRoles.VALIDATION_SPECIALIST]: validationSpecialistModules,
};
